export default "__VITE_ASSET__DRpFDEtT__"